import PublicMenu from "../components/publicSite/PublicMenu";
import PublicFooter from "../components/publicSite/PublicFooter";
import CookieConsent from "../components/publicSite/CookieConsent";
import UpcomingCompetitions from "../components/publicSite/UpcomingCompetitions";
import { Link } from "react-router-dom";
import "./HomePage.css";

const HomePage: React.FC = () => {

  return (
    <div className="home-page">
      <a href="#contenuto" className="home-skip-link">Vai al contenuto</a>
      <PublicMenu />
      <main id="contenuto" tabIndex={-1}>
        <section className="home-hero" aria-labelledby="home-title">
          <img src="/images/hero.jpg" alt="Le acque del Parco della Sciola, tra alberi e postazioni di pesca" width="1536" height="1016" className="home-hero__image" />
          <div className="home-container home-hero__content">
            <p className="home-hero__location">
              <svg aria-hidden="true" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7"><path d="M20 10c0 6-8 12-8 12S4 16 4 10a8 8 0 1 1 16 0Z" /><circle cx="12" cy="10" r="2.5" /></svg>
              Gualdo Tadino, Umbria
            </p>
            <h1 id="home-title">
              La tua giornata<br />di pesca, nel cuore<br />della natura.
            </h1>
            <p className="home-hero__description">Due laghi, la passione per la pesca e il piacere di stare insieme. Benvenuti al Parco della Sciola.</p>
            <div className="home-hero__actions">
              <a href="#laghi" className="home-button home-button--light">Scopri i laghi <span aria-hidden="true">↓</span></a>
              <a href="#prossime-gare" className="home-button home-hero__secondary">Prossime gare <span aria-hidden="true">↓</span></a>
            </div>
          </div>
        </section>

        <section className="home-lakes home-container" id="laghi" aria-labelledby="lakes-title">
          <div className="home-section-intro">
            <h2 id="lakes-title">Due laghi.<br />La stessa passione.</h2>
            <p>C'è chi cerca la tranquillità di una giornata all'aperto e chi l'emozione della prossima cattura. Qui c'è spazio per entrambe.</p>
          </div>
          <div className="home-lakes__grid">
            <article className="home-lake">
              <div className="home-lake__photo">
                <img src="/images/lago-principale.jpeg" alt="Il lago principale del Parco della Sciola con le montagne di Gualdo Tadino sullo sfondo" width="1080" height="1090" loading="lazy" decoding="async" />
                <span className="home-lake__tag">Pesca no kill · Natura e relax</span>
              </div>
              <div className="home-lake__content">
                <h3>Parco della Sciola</h3>
                <p>Carpe, amur e storioni per la tua giornata di pesca no kill. E una zona barbecue per stare in compagnia, tra famiglia e amici.</p>
              </div>
            </article>
            <article className="home-lake">
              <div className="home-lake__photo home-lake__photo--trout">
                <img src="/images/lago-2.jpeg" alt="Le sponde del Parco della Sciola 2, il lago dedicato al Trout Area" width="996" height="1600" loading="lazy" decoding="async" />
                <span className="home-lake__tag">Trout Area · Gare e campionati</span>
              </div>
              <div className="home-lake__content">
                <h3>Parco della Sciola 2</h3>
                <p>Un lago dedicato al Trout Area, dove allenarsi e mettersi alla prova. Il punto d'incontro per appassionati e agonisti da tutta Italia.</p>
              </div>
            </article>
          </div>
        </section>

        <UpcomingCompetitions />

        <section className="home-story home-container" id="vivi-il-parco" aria-labelledby="story-title">
          <div className="home-story__photo">
            <img src="/images/hero.jpg" alt="Il verde e la zona di ritrovo sulle rive del laghetto" width="1536" height="1016" loading="lazy" decoding="async" />
            <p>Il bello è anche<br />stare insieme.</p>
          </div>
          <div className="home-story__content">
            <h2 id="story-title">Più di una<br />giornata di pesca.</h2>
            <p>Dal 2018 ci prendiamo cura di un luogo speciale a Gualdo Tadino. Siamo partiti dallo storico “laghetto del postino” e da una passione da condividere.</p>
            <p>Oggi il Parco della Sciola è pesca sportiva, gare, incontri e tempo da dedicare alle persone con cui stai bene.</p>
            <Link to="/chi-siamo" className="home-text-link">La nostra storia <span aria-hidden="true">→</span></Link>
          </div>
        </section>

        <section className="home-visit home-container" aria-labelledby="visit-title">
          <div className="home-visit__inner">
            <div>
              <h2 id="visit-title">La prossima giornata<br />al lago ti aspetta.</h2>
              <p>Organizza la tua visita. Al resto pensa il parco.</p>
            </div>
            <nav className="home-visit__links" aria-label="Organizza la tua visita">
              <Link to="/dove-siamo">Come arrivare <span aria-hidden="true">↗</span></Link>
              <a href="tel:+393926556115">Chiamaci <span className="home-visit__phone">392 655 6115</span><span aria-hidden="true">↗</span></a>
            </nav>
          </div>
        </section>
      </main>
      <PublicFooter />
      <CookieConsent />
    </div>
  );
};

export default HomePage;
